module.exports = __webpack_public_path__ + "img/right-arrow-mob.e9cfb995.svg";